import { useRefreshOnPortalMessage } from './useRefreshOnPortalMessage';

const MESSAGE_TYPE = 'portal:transphere-payments-applied';

/**
 * Calls `record` with the batch counts when the AcombaGO host reports that Transphere payments were
 * applied in its Encaissement window. This is the same message `useRefreshOnTranspherePaymentsApplied`
 * listens to for the banner refresh, read here for its payload instead: AcombaGO reports how many
 * distinct invoices it saved and across how many distinct customers, which becomes the "Paiements
 * appliqués" general-history entry.
 *
 * Origin and message-shape validation are delegated to `useRefreshOnPortalMessage`; only the counts are
 * validated here. An older AcombaGO that posts the bare signal with no counts is ignored — no entry is
 * recorded until the host sends the batch counts as positive integers.
 */
export const useRecordTranspherePaymentsApplied = (
    record: (customersUpdated: number, invoicesApplied: number) => void,
): void => {
    useRefreshOnPortalMessage(MESSAGE_TYPE, (message) => {
        const customersUpdated = message.customersUpdated;
        const invoicesApplied = message.invoicesApplied;
        if (!isPositiveInteger(customersUpdated) || !isPositiveInteger(invoicesApplied)) return;

        record(customersUpdated, invoicesApplied);
    });
};

function isPositiveInteger(value: unknown): value is number {
    return typeof value === 'number' && Number.isInteger(value) && value >= 1;
}
